{
  "name": "43-(11-Limit) Partch (original ratios)",
  "description": "The classic 43-tone 11-Limit Rational Intonation scale by Harry Partch, consisting of 43 divisions per octave derived symmetrically from both harmonic and subharmonic partial rows (otonalities and utonalities) up to a prime limit of 11. The ratio notation follows Partch's original tuning, based on 1/1 = G (392 Hz). Note that the scala file uses the standard reference tone C, so each of Partch’s ratios must be multiplied by 3/2 and normalised to produce his original pitch-heights.",
  "scale": [
    "81/80",
    "33/32",
    "21/20",
    "15/14",
    "12/11",
    "10/9",
    "9/8",
    "8/7",
    "7/6",
    "33/28",
    "6/5",
    "27/22",
    "5/4",
    "81/64",
    "9/7",
    "21/16",
    "4/3",
    "27/20",
    "15/11",
    "11/8",
    "45/32",
    "10/7",
    "16/11",
    "40/27",
    "3/2",
    "243/160",
    "99/64",
    "63/40",
    "8/5",
    "18/11",
    "33/20",
    "5/3",
    "27/16",
    "12/7",
    "7/4",
    "16/9",
    "9/5",
    "11/6",
    "15/8",
    "21/11",
    "27/14",
    "63/32",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "43-JI-11L(Partch)",
  "built_in_group": "Rational Intonation (JI)",
  "key_labels": "note_names",
  "note_names": [
    "4/3",
    "27/20",
    "11/8",
    "7/5",
    "10/7",
    "16/11",
    "40/27",
    "3/2",
    "32/21",
    "14/9",
    "11/7",
    "8/5",
    "18/11",
    "5/3",
    "27/16",
    "12/7",
    "7/4",
    "16/9",
    "9/5",
    "20/11",
    "11/6",
    "15/8",
    "40/21",
    "64/33",
    "160/81",
    "1/1",
    "81/80",
    "33/32",
    "21/20",
    "16/15",
    "12/11",
    "11/10",
    "10/9",
    "9/8",
    "8/7",
    "7/6",
    "32/27",
    "6/5",
    "11/9",
    "5/4",
    "14/11",
    "9/7",
    "21/16"
  ],
  "note_colors": [
    "#ff9595",
    "#dee2da",
    "#dfffd6",
    "#ece6df",
    "#ecc9a2",
    "#cee3e2",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#ffe5e5",
    "#e4fbe6",
    "#dee2da",
    "#cee3e2",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#ffe5e5",
    "#d0d0d7",
    "#dee2da",
    "#e2eecd",
    "#dfffd6",
    "#fffae5",
    "#ecc9a2",
    "#cee3e2",
    "#fffae5",
    "#ffffff",
    "#dee2da",
    "#dfffd6",
    "#ece6df",
    "#dee2da",
    "#cee3e2",
    "#e2eecd",
    "#fffae5",
    "#e2eecd",
    "#e2caca",
    "#ffe5e5",
    "#d0d0d7",
    "#dee2da",
    "#dfffd6",
    "#fffae5",
    "#bae5f7",
    "#e2caca",
    "#ffe5e5"
  ],
  "equivSteps": 43,
  "fundamental": 392,
  "reference_degree": 25,
  "center_degree": 25,
  "rSteps": 7,
  "drSteps": 4,
  "hexSize": 42,
  "rotation": -16.102113751,
  "lumatone_anchor_note": 25,
  "lumatone_anchor_channel": 3
}
